export default {"src":"/_next/static/media/bell-ring.176acfd5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};